// Suit le format ParticipantQuizResponse du backend
// _correctChoiceId : champ extra client-only pour le feedback immédiat en mode démo

export const MOCK_QUIZ = {
    id: 0,
    questions: [
        {
            id: 1, orderIndex: 1, difficultyLevel: 'EASY', basePoints: 100, timeLimitSec: 10,
            text: 'Quelle nation a gagné la Coupe du Monde 2022 ?',
            _correctChoiceId: 2,
            choices: [
                { id: 1, orderIndex: 1, text: 'France' },
                { id: 2, orderIndex: 2, text: 'Argentine' },
                { id: 3, orderIndex: 3, text: 'Brésil' },
                { id: 4, orderIndex: 4, text: 'Croatie' },
            ],
        },
        {
            id: 2, orderIndex: 2, difficultyLevel: 'MEDIUM', basePoints: 200, timeLimitSec: 10,
            text: 'Contre qui la France perd-elle en finale en 2006 ?',
            _correctChoiceId: 8,
            choices: [
                { id: 5, orderIndex: 1, text: 'Brésil' },
                { id: 6, orderIndex: 2, text: 'Espagne' },
                { id: 7, orderIndex: 3, text: 'Portugal' },
                { id: 8, orderIndex: 4, text: 'Italie' },
            ],
        },
        {
            id: 3, orderIndex: 3, difficultyLevel: 'MEDIUM', basePoints: 200, timeLimitSec: 10,
            text: 'Le meilleur buteur absolu de l\'histoire du Mondial ?',
            _correctChoiceId: 10,
            choices: [
                { id: 9,  orderIndex: 1, text: 'Ronaldo (R9)' },
                { id: 10, orderIndex: 2, text: 'Miroslav Klose' },
                { id: 11, orderIndex: 3, text: 'Pelé' },
                { id: 12, orderIndex: 4, text: 'Just Fontaine' },
            ],
        },
        {
            id: 4, orderIndex: 4, difficultyLevel: 'HARD', basePoints: 300, timeLimitSec: 10,
            text: 'Quelle équipe a gagné le Mondial en perdant un match de poule ?',
            _correctChoiceId: 15,
            choices: [
                { id: 13, orderIndex: 1, text: 'L\'Argentine (2022)' },
                { id: 14, orderIndex: 2, text: 'L\'Espagne (2010)' },
                { id: 15, orderIndex: 3, text: 'Les deux' },
                { id: 16, orderIndex: 4, text: 'Aucune' },
            ],
        },
        {
            id: 5, orderIndex: 5, difficultyLevel: 'BOSS', basePoints: 400, timeLimitSec: 10,
            text: 'Quel Brésilien rate son tir au but face à la Croatie en 2022 ?',
            _correctChoiceId: 20,
            choices: [
                { id: 17, orderIndex: 1, text: 'Neymar' },
                { id: 18, orderIndex: 2, text: 'Casemiro' },
                { id: 19, orderIndex: 3, text: 'Rodrygo' },
                { id: 20, orderIndex: 4, text: 'Marquinhos' },
            ],
        },
    ],
};
